import React from "react";

import TimerButton from "./TimerButton";
import IncreaseDecreaseTimerButton from "./IncreaseDecreaseTimerButton";

import styles from "./main-timer-display.module.scss";

const LeftTimer = ({
    quarterParams,
    setTimersPerQuarter,
    timerSecondsSelected,
    setTimerSecondsSelected,
    matchId,
    matchData,
    setMatchData,
    matchStatus,
}) => {
    return (
        <div
            className={styles["left-timer"]}
            style={{
                ...(matchStatus > 3 || matchData.status === 2
                    ? { opacity: "0.3", pointerEvents: "none" }
                    : {}),
            }}
        >
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                }}
            >
                <TimerButton
                    time={1}
                    timerSecondsSelected={timerSecondsSelected}
                    setTimerSecondsSelected={setTimerSecondsSelected}
                />
                <TimerButton
                    time={10}
                    timerSecondsSelected={timerSecondsSelected}
                    setTimerSecondsSelected={setTimerSecondsSelected}
                />
                <TimerButton
                    time={30}
                    timerSecondsSelected={timerSecondsSelected}
                    setTimerSecondsSelected={setTimerSecondsSelected}
                />
            </div>

            <div
                style={{
                    margin: "5px 0 0 0",
                }}
            >
                <IncreaseDecreaseTimerButton
                    type="increase"
                    modifier="+"
                    timerSecondsSelected={timerSecondsSelected}
                    quarterParams={quarterParams}
                    setTimersPerQuarter={setTimersPerQuarter}
                    matchId={matchId}
                    matchData={matchData}
                    setMatchData={setMatchData}
                />
                <IncreaseDecreaseTimerButton
                    type="decrease"
                    modifier="-"
                    timerSecondsSelected={timerSecondsSelected}
                    quarterParams={quarterParams}
                    setTimersPerQuarter={setTimersPerQuarter}
                    matchId={matchId}
                    matchData={matchData}
                    setMatchData={setMatchData}
                />
            </div>
        </div>
    );
};

export default LeftTimer;
